module.exports = __webpack_public_path__ + "img/sce_p5_img_8.9777f671.png";